<template>
  <div class="bg-primary-white overflow-hidden w-full relative">
    <BaseContainer class="!px-0 lg:!px-5">
      <div :class="twJoin('flex flex-col-reverse lg:grid grid-cols-2')">
        <div
          :class="
            twJoin(
              'space-y-6 pt-8 pb-[58px] lg:py-[108px] lg:mr-[64px] px-5 lg:px-0 relative',
              reverse && 'lg:order-last lg:ml-[64px]'
            )
          "
        >
          <article class="text-black space-y-6">
            <h2 class="text-5xl">{{ title }}</h2>
            <p>
              {{ description ? description : '' }}
            </p>
          </article>
          <Button
            intent="secondary"
            class="min-w-[224px]"
            icon="arrow-up-right"
            @click="() => router.push(localPath(url))"
            >{{ buttonTitle }}</Button
          >
        </div>
        <div
          :class="
            twJoin('overflow-hidden w-full', reverse && 'overflow-visible')
          "
        >
          <img
            :alt="title?.toLowerCase() ?? ''"
            :src="imageUrl"
            :class="
              twJoin(
                'h-[240px] lg:h-full w-full lg:w-[50vw] object-cover object-center lg:absolute',
                reverse && 'lg:left-0'
              )
            "
          />
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
const router = useRouter()
const localPath = useLocalePath()
defineProps<{
  reverse?: boolean
  imageUrl: string
  title: string
  url: string
  description?: string
  buttonTitle: string
}>()
</script>
